import { usePage } from "@inertiajs/react"
import { Button, Flex } from "@radix-ui/themes"
import { ChevronsUpDown } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { UserInfo } from "@/components/user-info"
import { UserMenuContent } from "@/components/user-menu-content"
import { useIsMobile } from "@/hooks/use-mobile"
import type { SharedData } from "@/types"

export function NavUser() {
  const { auth } = usePage<SharedData>().props
  const isMobile = useIsMobile()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="3" className="group">
          <Flex align="center" gap="2">
            <UserInfo user={auth.user} />
            <ChevronsUpDown className="ml-auto size-4" />
          </Flex>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="min-w-56 rounded-lg"
        align="end"
        side={isMobile ? "bottom" : "bottom"}
      >
        <UserMenuContent auth={auth} />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
